export const PATIENT_MENU_CONTEXT = "patientMenu";
export const ADMIN_MENU_CONTEXT = "adminMenu";
export const MAIN_MENU_CONTEXT = "mainMenu";
